import { createAsyncThunk } from "@reduxjs/toolkit";
import { UsersAPI } from "api/api/usersApi/usersApi";
import { GetUsersParams, GetUsersRes } from "api/api/usersApi/types";
import axios from "axios";

export const getDisabledUsers = createAsyncThunk<GetUsersRes, GetUsersParams>(
  "users/getDisabledUsers",
  async (params, { rejectWithValue }) => {
    try {
      const response = await UsersAPI.getDisabledUsers(params);
      return response.data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while getting users details", error.response?.data);
        return rejectWithValue(error.response?.data || "Unknown error");
      }
      else {
        console.error("Error while getting users details", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);